/* IRELIO theme: product page gallery, variants, stand cards, sticky bar. */
(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  function parse(sel) { var el = root.querySelector(sel); try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var product = parse('[data-product-json]');
  var priceMap = parse('[data-price-map]') || {};
  var moneyFormat = parse('[data-money-format]') || '${{amount_no_decimals}}';

  /* ---------- gallery: swipe track, thumbnails (desktop), dots ---------- */
  var track = root.querySelector('[data-track]'), slides = $$('.slide'), thumbs = $$('.thumb'), dots = $$('[data-dots] i');
  function setActive(i) {
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
  }
  function goTo(i, instant) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: (reduce || instant) ? 'auto' : 'smooth' });
    setActive(i);
  }
  if (track) {
    var tk = false;
    track.addEventListener('scroll', function () {
      if (tk) return; tk = true;
      requestAnimationFrame(function () {
        tk = false;
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        setActive(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      var cur = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, cur + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, cur - 1)); }
    });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
  dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
  function showMedia(id) {
    if (!id) return;
    for (var i = 0; i < slides.length; i++) { if (String(slides[i].dataset.mediaId) === String(id)) { goTo(i); return; } }
  }

  /* ---------- money ---------- */
  function money(cents) {
    var n = cents / 100;
    var whole = Math.round(n).toLocaleString('en-PH');
    var dec = n.toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole).replace(/\{\{\s*amount\s*\}\}/, dec).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole);
  }

  /* ---------- options and variants ---------- */
  var form = root.querySelector('[data-product-form]');
  var priceEl = root.querySelector('[data-price]'), cmpEl = root.querySelector('[data-compare-price]'), idEl = root.querySelector('[data-variant-id]');
  var addBtn = root.querySelector('[data-add]'), buyBtn = root.querySelector('[data-buy-now]');
  var stickyPrice = root.querySelector('[data-price-sticky]'), stickyBtn = root.querySelector('[data-sticky-add]');
  var mirror = document.querySelector('[data-variant-id-mirror]');
  var groups = $$('[data-option-group][data-option-index]');
  var stickyStand = root.querySelector('[data-sticky-stand]');
  var noteEl = root.querySelector('[data-standnote]'), nameEl = root.querySelector('[data-selname]');

  function standValue() { var b = root.querySelector('.stands .stand[aria-checked=true]'); return b ? b.dataset.value : ''; }
  function syncStand() {
    if (!stickyStand) return;
    var v = standValue(), txt = v ? (/stand/i.test(v) ? v : v + ' stand') : '';
    /* chip swap: a short fade when the stand changes */
    if (stickyStand.textContent && stickyStand.textContent !== txt) { stickyStand.classList.remove('swap'); void stickyStand.offsetWidth; stickyStand.classList.add('swap'); }
    stickyStand.textContent = txt; stickyStand.hidden = !v;
  }
  if (stickyStand) {
    stickyStand.addEventListener('click', function () {
      var t = root.querySelector('.stands'); if (!t) return;
      var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 110, behavior: rm ? 'auto' : 'smooth' });
    });
  }
  function selection() { return groups.map(function (g) { var b = g.querySelector('[aria-checked=true]'); return b ? b.dataset.value : ''; }); }
  function findVariant(sel) {
    if (!product) return null;
    return product.variants.filter(function (v) {
      return sel.every(function (val, i) { return val === '' || v.options[i] === val; });
    })[0] || null;
  }
  function apply(v) {
    if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } if (buyBtn) buyBtn.disabled = true; if (stickyBtn) stickyBtn.disabled = true; return; }
    if (idEl) idEl.value = v.id;
    var xid = root.querySelector('[data-express-id]'); if (xid) xid.value = v.id;
    if (mirror) mirror.value = v.id;
    var pm = priceMap[v.id];
    if (priceEl) priceEl.textContent = pm ? pm.p : money(v.price);
    if (stickyPrice) stickyPrice.textContent = pm ? pm.p : money(v.price);
    if (cmpEl) { var has = v.compare_at_price && v.compare_at_price > v.price; cmpEl.hidden = !has; if (has) cmpEl.textContent = (pm && pm.c) ? pm.c : money(v.compare_at_price); }
    [addBtn, buyBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
    if (addBtn) addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (stickyBtn) stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
  }
  groups.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-value]'); if (!b) return;
      $$('[data-value]', g).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (g.querySelector('.stand')) {
        if (nameEl) nameEl.textContent = b.dataset.value;
        if (noteEl) noteEl.textContent = b.dataset.note || '';
      }
      apply(findVariant(selection()));
      syncStand();
    });
  });
  /* initial note for the stand picker */
  var sg = root.querySelector('[data-option-group] .stand[aria-checked=true]');
  if (sg && noteEl) noteEl.textContent = sg.dataset.note || '';

  /* preview stand cards (no Stand option yet): select visually only */
  var pv = root.querySelector('[data-preview-stands]');
  if (pv) {
    var first = pv.querySelector('.stand[aria-checked=true]');
    if (first && noteEl) noteEl.textContent = first.dataset.note || '';
    pv.addEventListener('click', function (e) {
      var b = e.target.closest('.stand'); if (!b) return;
      $$('.stand', pv).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      if (nameEl) nameEl.textContent = b.dataset.value;
      if (noteEl) noteEl.textContent = b.dataset.note || '';
      syncStand();
    });
  }
  syncStand();

  /* ---------- buy it now: add, then go to checkout ---------- */
  if (buyBtn && form) {
    buyBtn.addEventListener('click', function () {
      buyBtn.disabled = true;
      fetch((window.IRELIO && IRELIO.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); window.location.href = '/checkout'; })
        .catch(function () { buyBtn.disabled = false; var m = form.querySelector('[data-cart-error]'); if (m) { m.textContent = 'Could not start checkout. Please try again.'; m.hidden = false; } });
    });
  }

  /* ---------- sticky add to cart bar (phones): appears after the buy card ---------- */
  var sbar = root.querySelector('[data-sbar]'), card = root.querySelector('[data-buycard]');
  if (sbar && card) {
    var barTick = false;
    function syncBar() {
      barTick = false;
      var on = card.getBoundingClientRect().bottom < 0;
      sbar.classList.toggle('on', on);
      document.body.classList.toggle('sbar-on', on);
    }
    window.addEventListener('scroll', function () { if (!barTick) { barTick = true; setTimeout(syncBar, 60); } }, { passive: true });
    window.addEventListener('resize', syncBar);
    syncBar();
    /* tell the CSS how tall the bar really is (it grows on iPhones when Safari's toolbar slides away),
       so the WhatsApp button and the page bottom can follow it */
    var rootEl = document.documentElement;
    function publishBarH() {
      if (window.innerWidth < 960) rootEl.style.setProperty('--sbar-h', Math.round(sbar.getBoundingClientRect().height) + 'px');
      else rootEl.style.removeProperty('--sbar-h');
    }
    publishBarH();
    if (window.ResizeObserver) new ResizeObserver(publishBarH).observe(sbar, { box: 'border-box' });
    window.addEventListener('resize', publishBarH);
  }
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
  }

  /* ---------- copy the discount code ---------- */
  var copy = root.querySelector('[data-copy]');
  if (copy) {
    copy.addEventListener('click', function () {
      var t = copy.getAttribute('data-copy'), old = copy.textContent;
      function ok() { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = old; }, 1800); }
      try { navigator.clipboard.writeText(t).then(ok, function () { copy.textContent = t; }); } catch (e) { copy.textContent = t; }
    });
  }
})();
